import { render } from "./TheatreManagement.vue?vue&type=template&id=78396c7d&scoped=true"
import script from "./TheatreManagement.vue?vue&type=script&lang=js"
export * from "./TheatreManagement.vue?vue&type=script&lang=js"

import "./TheatreManagement.vue?vue&type=style&index=0&id=78396c7d&lang=css"
import "./TheatreManagement.vue?vue&type=style&index=1&id=78396c7d&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78396c7d"]])

export default __exports__